import { Link as RouterLink, useHistory } from "react-router-dom";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { ChangePassword } from "../../redux/actions/userActions";
import { toast } from "react-toastify";

import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

import AuthShell from "../auth/AuthShell";
import Spinner from "../common/Spinner";

const ChangePasswordPage = ({ match }) => {
  const history = useHistory();
  const token = match.params.token;
  const [submitted, setSubmitted] = useState(false);
  const dispatch = useDispatch();
  const [formState, setFormState] = useState({ values: {}, errors: {} });
  const [loading, setLoading] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);

  const validatePassword = (name, password) => {
    if (!password) {
      return name === "password" ? "Password is required" : "Confirm Password is required";
    }
    if (password.length < 6 || password.length > 15) {
      return name === "password"
        ? "Password must be between 6 and 15 characters"
        : "Confirm Password must be between 6 and 15 characters";
    }
    return null;
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormState((prev) => ({
      values: { ...prev.values, [name]: value },
      errors: { ...prev.errors, [name]: validatePassword(name, value) },
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);

    if (formState.errors.password) {
      toast.error(formState.errors.password);
      return;
    }
    if (formState.errors.confirm_password) {
      toast.error(formState.errors.confirm_password);
      return;
    }

    const { password, confirm_password } = formState.values;
    if (!password || !confirm_password) return;

    if (password !== confirm_password) {
      toast.error("Password and Confirm Password do not match.");
      return;
    }

    setLoading(true);
    dispatch(ChangePassword(password, token)).then((response) => {
      setLoading(false);
      if (response?.success === 1) history.push("/login");
    });
  };

  return (
    <>
      <AuthShell
        title="Create your password"
        subtitle="Choose a strong password you haven't used before."
        footer={
          <Typography variant="body2" align="center" sx={{ color: "text.secondary" }}>
            <Link component={RouterLink} to="/login" sx={{ fontWeight: 700 }}>
              Go back to sign in
            </Link>
          </Typography>
        }
      >
        <form onSubmit={handleSubmit} autoComplete="off" noValidate>
          <Stack spacing={2.5}>
            <TextField
              label="New password"
              type={passwordVisible ? "text" : "password"}
              name="password"
              required
              fullWidth
              autoFocus
              autoComplete="new-password"
              value={formState.values.password || ""}
              onChange={handleChange}
              error={Boolean((submitted && !formState.values.password) || formState.errors.password)}
              helperText={
                (submitted && !formState.values.password && "Password is required") ||
                formState.errors.password ||
                " "
              }
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setPasswordVisible((v) => !v)}
                      edge="end"
                      aria-label={passwordVisible ? "Hide password" : "Show password"}
                    >
                      {passwordVisible ? <VisibilityOffIcon /> : <VisibilityIcon />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            <TextField
              label="Confirm password"
              type={confirmPasswordVisible ? "text" : "password"}
              name="confirm_password"
              required
              fullWidth
              autoComplete="new-password"
              value={formState.values.confirm_password || ""}
              onChange={handleChange}
              error={Boolean(
                (submitted && !formState.values.confirm_password) || formState.errors.confirm_password
              )}
              helperText={
                (submitted && !formState.values.confirm_password && "Confirm Password is required") ||
                formState.errors.confirm_password ||
                " "
              }
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setConfirmPasswordVisible((v) => !v)}
                      edge="end"
                      aria-label={confirmPasswordVisible ? "Hide password" : "Show password"}
                    >
                      {confirmPasswordVisible ? <VisibilityOffIcon /> : <VisibilityIcon />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            <Button type="submit" variant="contained" size="large" fullWidth disabled={loading}>
              {loading ? "Saving…" : "Save new password"}
            </Button>
          </Stack>
        </form>
      </AuthShell>

      {loading && <Spinner fullscreen label="Updating your password…" />}
    </>
  );
};

export default ChangePasswordPage;
